import ClapperBoardIcon from '@/components/Icons/ClapperBoardIcon';
import ClipboardIcon from '@/components/Icons/icons/ClipboardIcon';
import EmailIcon from '@/components/Icons/icons/CustomContracts/EmailIcon';
import ImpressionsIcon from '@/components/Icons/icons/ImpressionsIcon';
import MoneyTagIcon from '@/components/Icons/icons/MoneyTagIcon';
import CommentIcon from '@/components/Icons/icons/PlayerIcon/CommentIcon';
import HeartLikeIcon from '@/components/Icons/icons/PlayerIcon/HeartLikeIcon';

export const SOCIAL_LISTENING_FILTERS = {
  PLATFORM: 'platformType',
  CONTENT_TYPE: 'contentType',
  CAMPAIGN: 'campaign',
  LISTS: 'lists',
  LABELS: 'labels',
  SORT_BY: 'sortBy',
};

export const SOCIAL_LISTENING_FILTER_OPTIONS = [
  // { key: SOCIAL_LISTENING_FILTERS.PLATFORM, label: 'Platform', IconComponent: AlbumIcon },
  { key: SOCIAL_LISTENING_FILTERS.CONTENT_TYPE, label: 'Content Type', IconComponent: ClapperBoardIcon },
  { key: SOCIAL_LISTENING_FILTERS.CAMPAIGN, label: 'Campaign', IconComponent: EmailIcon },
  { key: SOCIAL_LISTENING_FILTERS.LISTS, label: 'Lists', IconComponent: ClipboardIcon },
  { key: SOCIAL_LISTENING_FILTERS.LABELS, label: 'Labels', IconComponent: MoneyTagIcon },
];

export const SOCIAL_LISTENING_SORT_OPTIONS = [
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Impression', value: 'impressions', IconComponent: ImpressionsIcon },
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Comment', value: 'commentsCount', IconComponent: CommentIcon },
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Likes', value: 'likesCount', IconComponent: HeartLikeIcon },
];

export const SOCIAL_LISTENING_SORT_LABEL_MAP = {
  impressions: 'Impressions',
  commentsCount: 'Comments',
  likesCount: 'Likes',
};

export const SOCIAL_LISTEING_TABLE_HEADERS = [
  { text: 'Media' },
  { text: 'Type', align: 'center' },
  { text: 'Influencer Name' },
  { text: 'Username' },
  { text: 'Date' },
  { text: 'Impressions', align: 'right' },
  { text: 'Comments', align: 'right' },
  { text: 'Likes', align: 'right' },
  { text: 'Usage Rights', align: 'center' },
  { text: 'Labels', align: 'center' },
  { text: 'Actions', align: 'center' },
];
